module.exports = __webpack_public_path__ + "static/media/logo-mini.d16823d3.svg";